module.exports = __webpack_public_path__ + "media/scholarship_winners/caroline-sw-84fa71f1.png";